import PropTypes from 'prop-types';
import { Button, Icon } from '@evertrue/et-components';

const MapTableToggleButton = ({ view, onToggle = () => {} }) => {
  return (
    <div className="contact-table--map-toggle">
      {view === 'map' ? (
        <Button type="simple" onClick={() => onToggle('/contact')}>
          <Icon icon="table-large gt-icon-lg" />
          Table
        </Button>
      ) : (
        <Button type="simple" onClick={() => onToggle('/contact/map')}>
          <Icon icon="map gt-icon-lg" />
          Map
        </Button>
      )}
    </div>
  );
};

MapTableToggleButton.propTypes = {
  view: PropTypes.string.isRequired,
  onToggle: PropTypes.func,
};

export default MapTableToggleButton;
